(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("ManageParLaborController", ManageParLaborController);

    ManageParLaborController.$inject = ['$stateParams', '$modal', 'ParLaborDataService'];

    function ManageParLaborController ($stateParams, $modal, ParLaborDataService) {
        var self = this;

        var init = function () {
            self.forecastId = $stateParams['forecast_id'];
            self.startOfWeek = $stateParams['week'];
        };

        self.data = {};

        self.saveAsTemplate = function () {
            $modal({
                controller: 'SaveAsTemplateModal',
                controllerAs: 'saveAsTemplateModal',
                templateUrl: '../modules/team_schedule/employer/manage-par-labor/modals/save-as-template/save-as-template.form.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    onSave: function () {
                        return function (templateName) {
                            var parForecast = ParLaborDataService.prepareSavedData(angular.copy(self.data), null, self.startOfWeek, true, templateName);

                            if (parForecast.days && parForecast.days.length) {
                                ParLaborDataService
                                    .createParForecast(parForecast)
                                    .then(function (res) {
                                        HNotifications.show({
                                            title: $filter("translate")("Success"),
                                            desc: $filter("translate")("Template saved successfully!"),
                                            icon: "fa-check-circle",
                                            type: "success"
                                        });
                                    }, function (err) {
                                        console.error(err);
                                    });

                            } else {
                                hAlert({
                                    title: $filter("translate")("Warning"),
                                    text: $filter("translate")("You can’t save empty templates, please fill in values and try again."),
                                    custom_class: 'rejection-templates-error-alert',
                                    button: {
                                        text: $filter("translate")("Okay")
                                    }
                                });
                            }
                        }
                    }
                }
            });
        };

        self.loadFromTemplate = function () {
            ParLaborDataService
                .getParForecastsTemplates()
                .then(function (templates) {
                    $modal({
                        controller: 'LoadFromTemplateModal',
                        controllerAs: 'loadFromTemplateModal',
                        templateUrl: '../modules/team_schedule/employer/manage-par-labor/modals/load-from-template/load-from-template.modal.html',
                        show: true,
                        backdrop: 'static',
                        resolve: {
                            modalData: function () {
                                return {
                                    templates: templates
                                };
                            },
                            onSave: function () {
                                return function (templateId, includeSales) {
                                    ParLaborDataService
                                        .getWeekParForecast(templateId, self.startOfWeek)
                                        .then(function (parForecast) {
                                            var sales = self.data['weekSales'];
                                            self.data = angular.copy(parForecast);
                                            self.data['weekSales'] = includeSales ? self.data['weekSales'] : sales;

                                            HNotifications.show({
                                                title: $filter("translate")("Success"),
                                                desc: $filter("translate")("Template loaded successfully!"),
                                                icon: "fa-check-circle",
                                                type: "success"
                                            });

                                        }, function (err) {
                                            console.error(err);
                                        });
                                }
                            }
                        }
                    });
                }, function (err) {
                    console.error(err);
                });
        };

        init();
    }
})();